import SupervisorHome from "../views/Supervisor/SupervisorHome";

const navRoutesAplSupervisor = [
  { path: "/", exact: true, name: "Home", component: SupervisorHome },
  { path: "/supervisor", exact: true, name: "Home", component: SupervisorHome },
];

export default navRoutesAplSupervisor;
